(ns frontend.view.workspaces.kyc-workspace
  (:require
   [common.localization :as loc]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.nev.kyc.process-status-views.signatures-status :as signatures-status]
   [frontend.view.nev.kyc.process-status-views.waiting-for-esign-status :as waiting-for-esign-status]
   [frontend.view.nev.kyc.process-status-views.wip-status :as wip-status]
   [reagent.core :as r]
   [ui.components.card.view :as card]
   [common.schema.entities.workspace.kyc.templates.innovestor.company-config :as innovestor-company-config]))

(defn no-access
  [tenant-name kyc-process]
  (let [lang (:kyc-process/language kyc-process)]
    [:div.zap-page
     [:div.d-flex.flex-column.flex-1-hidden
      [:div.d-flex.flex-column.flex-1-hidden.scroll-y-container
       [:div.d-flex.flex-column.flex-1-hidden.scroll-y
        [:div.container.pt-4
         [card/card
          [card/body
           [:img.horizontal-page__body-top-logo
            {:src (case tenant-name
                    "CapMan" "/img/customer/capman/CapMan_logo_green.png"
                    "Innovestor" innovestor-company-config/png-logo)}]
           [:h1
            (loc/tr :kyc-form-submitted-title nil lang)]]]]]]]]))

(defn view
  [_kyc-process]
  (let [state-atom (r/atom {})
        local-atom (r/atom {})
        field-errors-atom (r/atom {})]
    (fn [kyc-process]
      (let [kyc-process (get @session/entities (:db/id kyc-process))
            save! (fn []
                    (entity-actions/*->field-update!
                     (:db/id kyc-process)
                     :kyc-process/answers
                     (pr-str (:kyc-process/answers @state-atom))
                     (fn [_resp])
                     (fn [error]
                       (logging/error "Failed to autosave answers : " error))))]
        [:div.zap-page
         (case (:kyc-process/status kyc-process)
           :kyc-process.status/wip [wip-status/view state-atom kyc-process save! field-errors-atom]
           :kyc-process.status/waiting-for-e-sign [waiting-for-esign-status/view state-atom local-atom kyc-process save!]
           :kyc-process.status/esign-in-progress [waiting-for-esign-status/view state-atom local-atom kyc-process save!]
           :kyc-process.status/signatures [signatures-status/view state-atom local-atom kyc-process save!]
           [no-access @session/tenant-name kyc-process])]))))
